/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ErrorsModule } from "./@core/errors";
import { NotificationService } from "./@core/services/notification.service";

import { AppComponent } from "./app.component";
import { NotificationsComponent } from "./pages/components/notifications/notifications.component";
import { ToasterModule } from "angular2-toaster";

import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "./@theme/theme.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
// import { NgDatepickerModule } from 'ng2-datepicker';
import { NgBusyModule } from "ng-busy";
import { AppConfigService } from "./app-config.service";
import { LoginComponent } from "./login/login.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";
import { TokenInterceptor } from "./@core/http-interceptors/token.interceptor";
import { CookieService } from "ngx-cookie-service";
import { CommaValueValidatorDirective } from "./pages/cms/challenge/csv-input.directive";

import { UserIdleModule } from "angular-user-idle";
import { environment } from "../environments/environment";
import { CacheInterceptor } from "./@core/http-interceptors/cache.interceptor";

let timeoutSec = environment.sessionTimeout * 60;

const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [
    AppComponent,
    NotificationsComponent,
    LoginComponent,
    MaintenanceComponent,
    CommaValueValidatorDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ErrorsModule,

    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    ToasterModule.forRoot(),
    // NgDatepickerModule
    NgBusyModule,

    // Optionally you can set time for `idle`, `timeout` and `ping` in seconds.
    // Default values: `idle` is 600 (10 minutes), `timeout` is 300 (5 minutes)
    // and `ping` is 120 (2 minutes).

    UserIdleModule.forRoot({ idle: timeoutSec - 10, timeout: 10, ping: 120 }),
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    NotificationService,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService],
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    CookieService,
  ],
  exports: [CommaValueValidatorDirective],
})
export class AppModule {}
